const module = {
  config: {
    name: 'gallery-folders-module-archieve',
    icon: 'ri-user-line',
    desc: '',
    group: 'Postingan Diarsipkan',
    layout: true
  },
  routes: [
    { name: 'gallery-folders-archieve', label: 'Galeri', icon: 'ri-image-2-fill', path: '/gallery-folders-archieve', component: () => import('./gallery-folders-archieve.vue') }
  ]
}
export default module



// WEBPACK FOOTER //
// ./src/modules/gallery-folders-archieve/_index.js